import { Component } from '@angular/core';
import { MessageBoxHelper } from '../../../components/dialogs/messagebox/messagebox.dialog';
import { TranslateFormatText } from '../../../helpers/array.helpers';
import { MessageBoxButtons } from '../../../models/enums/messageboxbuttons.enum';
import { MessageBoxIcon } from '../../../models/enums/messageboxicon.enum';

/**
 * Verwaltet die Indexe eines ClassObject-Containers.
 *
 * Gezeigt werden die Definitionen am Container und daneben, was in der Ablage tatsaechlich
 * liegt -- beides kann auseinanderlaufen, etwa wenn jemand von Hand in der Datenbank
 * gearbeitet hat. Angelegt und entfernt wird beim Speichern des Containers.
 */
@Component({
    selector: 'dataobject-index-dialog',
    templateUrl: './dataobject.index.dialog.html',
    styleUrls: ['./dataobject.index.dialog.css']
})
export class DataObjectIndexDialog {
    Indexes = [];
    AvailableFields = [];
    Existing = [];
    StorageSupportsIndexes = true;
    Error = null;

    Initialize(args) {
        if (args) {
            // Copy the raw object and only overlay what this dialog edits -- everything else
            // (e.g. the marker of automatically created indexes) must go back unchanged.
            this.Indexes = (args.Indexes || []).map(x => ({
                ...x,
                Fields: [...(x.Fields || [])],
                Unique: x.Unique === true
            }));
            this.AvailableFields = args.AvailableFields || [];
            this.Existing = args.Existing || [];
            this.StorageSupportsIndexes = args.StorageSupportsIndexes !== false;
            this.Error = args.Error;
        }
    }

    GetDialogResult() {
        return this.Indexes.filter(x => x.Fields && x.Fields.length > 0);
    }

    OnDialogButtonClickAction(button) {
        if (button === 0) {
            const empty = this.Indexes.some(x => !x.Fields || x.Fields.length === 0);
            if (empty) {
                MessageBoxHelper.ShowDialog(
                    new TranslateFormatText('@@Mindestens ein Index hat keine Felder. Er wird nicht gespeichert.'),
                    new TranslateFormatText('@@Indexe'), MessageBoxButtons.Ok, MessageBoxIcon.Information);
            }
        }
        return true;
    }

    /**
     * Ein von der Query-Engine angelegter Index wird zum eigenen, sobald jemand ihn bearbeitet
     * oder ausdruecklich behaelt -- er ist dann nicht mehr das, was die Engine angelegt hat.
     */
    Keep(entry) {
        entry.Automatic = false;
    }

    Add() {
        this.Indexes.push({ Fields: [], Unique: false });
    }

    Remove(index) {
        this.Indexes.splice(index, 1);
    }

    /** Die Reihenfolge entscheidet, welche Abfragen der Index bedient -- deshalb verschiebbar. */
    MoveUp(entry, pos) {
        this.Keep(entry);
        if (pos > 0) {
            const field = entry.Fields.splice(pos, 1)[0];
            entry.Fields.splice(pos - 1, 0, field);
        }
    }

    MoveDown(entry, pos) {
        this.Keep(entry);
        if (pos < entry.Fields.length - 1) {
            const field = entry.Fields.splice(pos, 1)[0];
            entry.Fields.splice(pos + 1, 0, field);
        }
    }

    RemoveField(entry, pos) {
        this.Keep(entry);
        entry.Fields.splice(pos, 1);
    }

    AddField(entry, name) {
        this.Keep(entry);
        if (name && entry.Fields.indexOf(name) < 0) {
            entry.Fields.push(name);
        }
    }
}
